// actions.js
import * as actionTypes from './actionsTypes';

export const setValuePme = (value) => ({
  type: actionTypes.SET_VALUE_PME,
  payload: value,
});

export const setStatutPme = (statut) => ({
  type: actionTypes.SET_STATUT_PME,
  payload: statut,
});
export const setCategoriePme = (categorie) => ({
  type: actionTypes.SET_CATEGORIE_PME,
  payload: categorie,
});

export const setProduitPme = (produit) => ({
  type: actionTypes.SET_PRODUIT_PME,
  payload: produit,
});

export const setCurrentPagePme = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_PME,
  payload: page,
});

export const setOrderPme = (order) => ({
  type: actionTypes.SET_ORDER_PME,
  payload: order,
});

export const setSortFieldPme = (field) => ({
  type: actionTypes.SET_SORT_FIELD_PME,
  payload: field,
});
  
  
  

  
  